/**
 * Created by lari on 24/04/2017. **/

(function () {
  'use strict';
  angular.module('vcdms.vcdocument')
    .component('complexdocumentlist', {
      restrict: 'E',
      bindings: {
        documents: '<?',
        key: '@?',
        value: '@?'
      },
      templateUrl: 'vcdms/document/complexdocumentlist-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Document', 'Rlog', '$scope', 'uiGridConstants', 'vertxEventBusService',
        function ($log, $http, Document, Rlog, $scope, uiGridConstants, vertxEventBusService) {
          let vm = this;
          vm.documentactiontemplate = 'documentactiontemplate';
          vm.documenttagtemplate = 'documenttagtemplate';
          vm.getTags = getTags;
          vm.saveDocument = saveDocument;
          vm.removeDocument = removeDocument;
          // vm.unlinkdocument = unlinkdocument;
          vm.spinners = [];

          vm.$onInit = function () {
            if (angular.isUndefined(vm.documents)) {
              if (angular.isString(vm.key) && angular.isString(vm.value)) {
                vm.documents = Document.$searchMetaBy(vm.key, vm.value);
              }
              else {
                vm.documents = Document.$search();
              }
            }

            vm.gridOptions = {
              enableFiltering: true,
              enableSorting: true,
              columnDefs: [
                {
                  field: 'created', displayName: 'Datum', type: 'date', width: '15%',
                  cellTemplate: '<div class="ui-grid-cell-contents"><span>{{row.entity.created | moment: \'lll\'}}</span></div>',
                  filters: [
                    {
                      condition: uiGridConstants.filter.GREATER_THAN,
                      placeholder: 'nach'
                    },
                    {
                      condition: uiGridConstants.filter.LESS_THAN,
                      placeholder: 'vor'
                    }
                  ],
                  sort: {
                    direction: uiGridConstants.DESC,
                    priority: 1
                  }
                },
                {
                  field: 'type', displayName: 'Typ', width: '40%',
                  filter: {
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: 'beinhaltet ...'
                  }
                },
                {
                  displayName: 'Stichworte', name: 'flattags', cellClass: 'gridalignleft', width: '33%',
                  cellTemplate: vm.documenttagtemplate, enableFiltering: true, enableSorting: false,
                  filter: {
                    condition: uiGridConstants.filter.CONTAINS,
                    placeholder: 'beinhaltet ...'
                  }
                },
                {
                  displayName: 'Aktion', name: 'documentaction', cellClass: 'gridalignright', width: '12%',
                  cellTemplate: vm.documentactiontemplate, enableFiltering: false, enableSorting: false
                }
              ],
              data: vm.documents,
              onRegisterApi: function (gridApi) {
                vm.gridApi = gridApi;
              }
            };


          }; // $onInit()


          function getTags(val) {
            // TODO: evaluate need for ^ regex to beginning of tag
            // let myregex = '^' + val; // when using $regex, do not include '/' for regex delimiter
            let myregex = val; // when using $regex, do not include '/' for regex delimiter
            let match = [
              {$match: {flattags: {$regex: myregex, $options: 'i'}}},
              {$unwind: '$flattags'},
              {$match: {flattags: {$regex: myregex, $options: 'i'}}},
              {$group: {_id: '$flattags', total: {$sum: 1}}}];

            return $http.post('/routes/binarypdf/aggregate', match).then(function (response) {
              $log.debug('complexdoclist tags received: ', response);
              let tags = new Set();
              if (angular.isDefined(response) && angular.isDefined(response.data) && response.data.length > 0) {
                // create set to group by value
                tags = new Set(response.data.map(function (tag) {
                  return tag._id;
                }));
                $log.debug('complexdoclist tags from result array: ', tags);
              }
              else if (angular.isDefined(response) && angular.isDefined(response.data) &&
                       angular.isDefined(response.data._id)) {
                tags = new Set([response.data._id]);
                $log.debug('complexdoclist tags from single result: ', tags);

              }
              // return array because ngTagsLib expects an array not a set
              $log.debug('complexdoclist Array from tags set: ', Array.from(tags), tags);
              return Array.from(tags);
            });
          }


          function saveDocument(doc) {
            $log.debug('complex document lsit - savedocument called! ', doc.keywords);
            let flattags = [];
            $log.debug('doc: ', doc);
            if (angular.isArray(doc.keywords)) {
              for (let i = 0; i < doc.keywords.length; i++) {
                flattags.push(doc.keywords[i].text);
              }
              doc.flattags = flattags;
              doc.$save().$then(function () {
                vm.documents.$refresh().$then(function () {
                  vm.gridApi.core.refresh();
                });
              });
            }
          }

          function removeDocument(ldocument) {
            ldocument.active = false;
            ldocument.$save().$then(function () {
              vm.documents.$refresh();
              vm.gridApi.core.refresh();
            });
          }

          vertxEventBusService.on('documents.create', function (message) {
            $log.debug('debug: document update received: ', message);
            vm.documents.$refresh().$then(function () {
              $log.debug('debug: documentlist refreshed documents');
            }, function (error) {
              $log.debug('debug: documentlist refresh documents failed: ', error);
            });
          });

        }] // controller
    }); // component

  // klammerfriedhof
}());
